import ProgressCard from "../../biblio/progress/ProgressCard";
import Perso from "../../assets/icons/Perso.svg";
import location from "../../assets/icons/location-border.svg";
import cursor from "../../assets/icons/cursor-icon.svg";
import doc from "../../assets/icons/doc-icon.svg";
import click from "../../assets/icons/tab-click-icon.svg";
import { Col, Row } from "antd";
import { toFormatAmount } from "../utils/utils";
import { useEffect, useState } from "react";

interface CardProps {
  project: any;
  type: "المشاريع" | "تفريج كرب" | "التبرع العام";
}

const CardDetailsProject = ({ project, type }: CardProps) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="takaful--card-details-project-container">
      <div
        className="takaful--card-details-project-image"
        style={{
          backgroundImage:
            type === "المشاريع"
              ? `url(${
                  project?.detail_image_ids && project?.detail_image_ids[0]
                    ? project?.detail_image_ids[0]
                    : null
                })`
              : type === "تفريج كرب" || type === "التبرع العام"
              ? `url(${
                  project?.detail_image_ids && project?.detail_image_ids[0]
                    ? project?.detail_image_ids[0]
                    : null
                })`
              : `url(${project?.image})`,
        }}
      >
        {type === "المشاريع" && (
          <div className="takaful--card-details-project-name">
            <span>{project?.request_type_id}</span>
          </div>
        )}
      </div>

      <Row gutter={16} justify={"space-between"} dir="rtl">
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col
          xxl={17}
          xl={17}
          lg={17}
          md={17}
          sm={24}
          xs={24}
          className="takaful--card-details-project-titles"
          style={{ marginTop: "3vh" }}
        >
          <span className="takaful--card-details-project-title">
            {type === "المشاريع"
              ? project?.project_name
              : type === "التبرع العام"
              ? project?.name
              : project?.summary}
          </span>

          <span className="takaful--card-details-project-text">
            {type === "المشاريع"
              ? project?.brief
              : type === "التبرع العام"
              ? project?.summary
              : ""}
          </span>

          {type === "المشاريع" && (
            <Row gutter={32}>
              <Col
                className="takaful--card-details-project-info-1"
                xxl={8}
                xl={8}
                lg={12}
                md={12}
                sm={10}
                xs={10}
              >
                <img src={Perso} alt="person" />
                <span>{project?.target_number} أفراد</span>
              </Col>
              <Col
                className="takaful--card-details-project-info-1"
                xxl={8}
                xl={8}
                lg={12}
                md={12}
                sm={12}
                xs={12}
              >
                <img src={location} alt="place" />
                <span>المدينة المنورة</span>
              </Col>
            </Row>
          )}
        </Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={1} xs={1} />
        {type === "المشاريع" && (
          <Col
            className="takaful--card-details-project-qr"
            xxl={5}
            xl={5}
            lg={5}
            md={5}
            sm={15}
            xs={10}
          >
            <span style={{ lineHeight: "1.25rem" }}>
              رقم الترخيص: {project?.license_number}
            </span>

            {project?.license_attachment_ids?.length > 0 && (
              <img
                width={120}
                src={project?.license_attachment_ids[0]}
                alt="qr-code"
              />
            )}
          </Col>
        )}

        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
      </Row>

      {(type !== "المشاريع" || project?.show_progress_details) && (
        <>
          <Row gutter={16} style={{ paddingTop: "2rem" }}>
            <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
            <Col xxl={22} xl={22} lg={22} md={22} sm={22} xs={22}>
              <ProgressCard
                percent={Math.floor(project?.progress)}
                percentPosition={{
                  align: "end",
                  type: "inner",
                }}
                size={["100%", 15]}
              />
            </Col>
            <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
          </Row>

          {/* Donation */}
          <Row gutter={16} style={{ paddingTop: "2rem" }}>
            <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
            <Col
              className="takaful--card-details-project-info-donation"
              xxl={22}
              xl={22}
              lg={22}
              md={22}
              sm={22}
              xs={22}
            >
              <div className="takaful--card-details-project-info-donation-target">
                <span>{type === "المشاريع" ? "تم جمع" : "المستهدف"}</span>
                <p>
                  {type === "المشاريع"
                    ? toFormatAmount(
                        project.target_amount - project.residual_amount
                      )
                    : toFormatAmount(project?.amount)}
                </p>
              </div>
              <div className="takaful--card-details-project-info-donation-divider"></div>
              <div className="takaful--card-details-project-info-donation-amount">
                <span>المبلغ المتبقي</span>
                <p>
                  {type === "المشاريع"
                    ? toFormatAmount(project?.residual_amount)
                    : toFormatAmount(project?.remaining_amount)}
                </p>
              </div>
            </Col>
            <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
          </Row>
        </>
      )}

      {/** Description */}
      <Row gutter={16} style={{ paddingTop: "2rem" }}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col
          className="takaful--card-details-project-description"
          xxl={22}
          xl={22}
          lg={22}
          md={22}
          sm={22}
          xs={22}
        >
          {type === "التبرع العام" ? (
            <span>شارك معنا لمن تحب هذا التبرع العام ، ساهم في اسعادهم</span>
          ) : type === "المشاريع" ? (
            <span>شارك معنا لمن تحب هذا المشروع، ساهم في اسعادهم</span>
          ) : (
            <span>شارك معنا لمن تحب هذه الحالة، ساهم في اسعادهم</span>
          )}
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
      </Row>

      {/** Statistics */}
      <Row
        gutter={16}
        justify={isMobile ? "center" : "space-between"}
        style={{ paddingTop: "2rem" }}
      >
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
        <Col xxl={7} xl={7} lg={7} md={7} sm={22} xs={22}>
          <div
            className="takaful--card-details-project-statistics takaful--card-details-project-statistics-first 
              takaful--card-details-project-border-right"
          >
            <div className="takaful--card-details-project-statistics-title">
              <span>آخر تبرع</span>
              <img width={30} height={30} src={cursor} alt="card-details" />
            </div>
            <span>{project?.last_payment_period}</span>
          </div>
        </Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={7} xl={7} lg={7} md={7} sm={22} xs={22}>
          <div className="takaful--card-details-project-statistics takaful--card-details-project-border-center">
            <div className="takaful--card-details-project-statistics-title">
              <span>عدد الزيارات</span>
              <img width={30} height={30} src={click} alt="card-details" />
            </div>
            <span>{project?.visit_count}</span>
          </div>
        </Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={0} xl={0} lg={0} md={0} sm={0} xs={0}></Col>
        <Col xxl={7} xl={7} lg={7} md={7} sm={22} xs={22}>
          <div className="takaful--card-details-project-statistics takaful--card-details-project-border-left">
            <div className="takaful--card-details-project-statistics-title">
              <span>عدد التبرعات</span>
              <img width={30} height={30} src={doc} alt="card-details" />
            </div>
            <span>{project?.donation_number}</span>
          </div>
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
      </Row>
    </div>
  );
};

export default CardDetailsProject;
